/**
 * Pick a real shop slug for loyalty wallet/coupons APIs.
 * Prefer isCurrentTenant ACTIVE; else first ACTIVE with a usable API tenant.
 * Never returns `__platform__` / reserved path segments.
 */
import { hasCustomerApiTenant } from '../../../shared/tenant/customerApiTenant.js';
import type { CustomerMembershipItemDTO } from '../accountTypes.js';

function membershipIsActive(
  item: Pick<CustomerMembershipItemDTO, 'membershipStatus' | 'status'>,
): boolean {
  const status = item.membershipStatus ?? item.status;
  return status === 'ACTIVE';
}

export function pickLoyaltyApiTenantFromMemberships(
  memberships: readonly CustomerMembershipItemDTO[] | undefined | null,
): string | null {
  if (memberships == null || memberships.length === 0) {
    return null;
  }

  const activeApi = memberships.filter(
    (m) => membershipIsActive(m) && hasCustomerApiTenant(m.tenantCode ?? ''),
  );
  if (activeApi.length === 0) {
    return null;
  }

  const current = activeApi.find((m) => m.isCurrentTenant === true);
  const chosen = current ?? activeApi[0];
  const code = chosen?.tenantCode?.trim() ?? '';
  return hasCustomerApiTenant(code) ? code : null;
}
